import NavCard from "./NavCard";
import "../styles.css";
import React from "react";

// ✅ IMPORT YOUR BANNERS
import banner1 from "../../assets/banner1.jpeg";
import banner2 from "../../assets/banner2.jpeg";
import banner3 from "../../assets/banner3.jpeg";

const ProductBar = () => {

    const categories = [
        { id: 1, img: banner1, type: "Trending Moti ear cup" },
        { id: 2, img: banner2, type: "Trending Moti ear cup" },
        { id: 3, img: banner3, type: "Trending Moti ear cup" },
        { id: 4, img: banner1, type: "Trending Moti ear cup" },
        { id: 5, img: banner2, type: "Trending Moti ear cup" },
        { id: 6, img: banner3, type: "Trending Moti ear cup" },
        { id: 7, img: banner1, type: "Trending Moti ear cup" },
        { id: 8, img: banner2, type: "Trending Moti ear cup" },
        { id: 9, img: banner3, type: "Trending Moti ear cup" }
    ];

    return (
        <div className="nav-items-container">
            {categories.map((category) => (
                <NavCard key={category.id} props={category} />
            ))}
        </div>
    );
};

export default ProductBar;